import React from 'react';
import { useTheme } from 'theming';
import useStyles from './styles';
import clsx from 'clsx';
const Paper = ({ children, variant, customClassName = '', inlineStyles = {}, regular = false }) => {
    const theme = useTheme();
    const classes = useStyles({ theme });
    const containerStyles = clsx({
        [classes.container]: true,
        [classes[variant]]: variant && !regular,
        [classes[`${variant}_regular`]]: variant && regular,
        [classes.default]: variant,
        [customClassName]: customClassName
    });
    return (React.createElement("div", { className: containerStyles, style: inlineStyles }, children));
};
export { Paper };
//# sourceMappingURL=Paper.js.map